import React from 'react';
import { ButtonModalProps } from '../types/modal';
import { StyledButton } from '../styles';

export const ButtonModal: React.FC<
  ButtonModalProps & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ disabled = false, children, ...props }) => {
  return (
    <StyledButton disabled={disabled} {...props}>
      {children}
    </StyledButton>
  );
};
